import { i18nLanguage, languages } from "consts";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import authEN from "./en/auth.json";
import authES from "./es/auth.json";
import authPT from "./pt/auth.json";

import commonsEN from "./en/commons.json";
import commonsES from "./es/commons.json";
import commonsPT from "./pt/commons.json";

import componentsEN from "./en/components.json";
import componentsES from "./es/components.json";
import componentsPT from "./pt/components.json";

export const resources = {
  pt: {
    auth: authPT,
    commons: commonsPT,
    components: componentsPT,
  },
  en: {
    auth: authEN,
    commons: commonsEN,
    components: componentsEN,
  },
  es: {
    auth: authES,
    commons: commonsES,
    components: componentsES,
  },
};

const languagePathDetector = {
  name: "languagePathDetector",
  lookup() {
    const path = window.location.pathname;
    const firstItemPath = path?.split("/")?.[0 || 1];
    const defaultLanguage = window.localStorage.getItem(i18nLanguage) || "";
    return languages.some((language) => language === firstItemPath)
      ? firstItemPath
      : defaultLanguage;
  },
};

const detector = new LanguageDetector();
detector.addDetector(languagePathDetector);

i18next
  .use(initReactI18next)
  .use(detector)
  .init({
    debug: false,
    ns: ["auth", "commons", "components"],
    defaultNS: "commons",
    fallbackNS: "commons",
    fallbackLng: languages,
    detection: {
      order: ["languagePathDetector"],
      lookupLocalStorage: i18nLanguage,
    },
    interpolation: {
      escapeValue: false,
    },
    resources,
    returnNull: false,
  });

export default i18next;
